import React from 'react'
import './Loading.css'

export default function Loading() {
    return (
        <div>
            <h2 id='loadText'>loading...</h2>
        </div>
    )
}
